import React, { Component } from 'react';
import { Form, DatePicker } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/zh_CN';
import util from '@/api/util';

const RangePicker = DatePicker.RangePicker;

class DatePicker_C extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultValue: '',
            className: props.className ? props.className : ''
        }
    }

    componentDidMount() {
        const { feild, setValue, format, type, initialValue } = this.props;
        console.log(initialValue)
        if (!initialValue) {
            setValue(feild, moment(util.formatTimestamp((new Date()).getTime()), format));
        };
    }

    render() {
        const { className } = this.state
        const { format, setValue, type, showTimeFlag, width, feild, initialValue, disabledDate, disabled } = this.props;
        console.log(initialValue)
        const { defaultValue } = this.state;
        const renderDom = () => {
            if (type == 0) {
                return (
                    <DatePicker
                        className={className}
                        placeholder="设置结束时间"
                        showTime={showTimeFlag}
                        format={format}
                        locale={locale}
                        defaultValue={initialValue ? moment(initialValue, format) : moment(util.formatTimestamp((new Date()).getTime()), format)}
                        style={{ width: width ? width : "240px" }}
                        onChange={(date, dateString) => {
                            setValue(feild, date)
                        }}
                    />
                )
            } else {
                return (
                    <RangePicker
                        disabled={disabled}
                        placeholder={['开始时间', '结束时间']}
                        format={format}
                        locale={locale}
                        showTime={showTimeFlag}
                        style={{ width: width ? width : "240px" }}
                        disabledDate={disabledDate && disabledDate}
                        defaultValue={initialValue ? [moment(initialValue[0], format), moment(initialValue[1], format)] : null}
                        onChange={(date, dateString) => {
                            if (this.props.callback) {
                                this.props.callback(date)
                            }
                            setValue(feild, date)
                        }}
                    />
                )
            }
        }
        return (
            renderDom()
        )
    }
}

DatePicker_C.propTypes = {
    type: PropTypes.number.isRequired, //0为时间选择，1为时间范围选择
    setValue: PropTypes.func.isRequired,
    format: PropTypes.string.isRequired,
    showTimeFlag: PropTypes.bool.isRequired, //是否显示时间选择面板
    feild: PropTypes.string.isRequired,
}

export default DatePicker_C
